import React from 'react'

import _ from 'lodash'

import {Alert, H3, P, Row, Card} from '../../../../components/UI/index.js'
import EmailPreview from '../../../../components/settings/EmailPreview.js'
import {formSpacing, FormStack, Input, Editor, UploadImage} from '../../../../components/UI/forms/index.js'
import LoginActions from '../../../../actions/LoginActions.js'
import t from 'src/helpers/Languages.js'

import userWelcomeTemplate from '../../../../../server/functions/mail/templates/userWelcomeTemplate.js'
import defaultWelcomeUserBody from '../../../../../server/models/resellerDefaults/defaultWelcomeUserBody.js'
import {welcomeMailPhoto} from '../../../../../utils/trackTraceBranding.js'
import {trackTracePhotoSizes} from '../../../../../types/trackTrace.js'

const DEFAULT_SUBJECT = 'Account voor Veloyd'

// Welcome mail for new users (planners and couriers): subject, message and photo, like the welcome mail for customers
class UserWelcomeSettings extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            photoError: ''
        }
    }

    onChangeValue(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.value)

        this.props.onChange(reseller)
    }

    onSaveValue(path, event) {
        const reseller = {...this.props.reseller}

        if (event) {
            _.set(reseller.settings, path, event.target.value)
        }

        this.props.onChange(reseller, path)
    }

    // The photo is saved as a file on the server, which checks the minimum size
    onChangePhoto(dataUrl) {
        this.setState({photoError: ''})

        LoginActions.setTrackTracePhoto('welcomeUser', dataUrl || null, (err, id) => {
            if (err) {
                this.setState({photoError: err})
                return
            }

            const reseller = {...this.props.reseller}
            _.set(reseller.settings, 'users.welcomeEmailPhoto', id || undefined)
            this.props.onChange(reseller)
        })
    }

    render() {
        const {reseller} = this.props
        const users = reseller.settings.users || {}
        const {width, height} = trackTracePhotoSizes.welcomeUser
        const photo = welcomeMailPhoto(reseller, 'welcomeUser')
        const body = users.welcomeEmailBody || defaultWelcomeUserBody

        return (
            <Row style={{gap: 24}}>
                <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                    <H3 style={{marginBottom: 12}}>{t('welcomeMailUsers')}</H3>
                    <P style={{marginBottom: 36}}>{t('welcomeMailUsersInfo')}</P>

                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label={t('mailSubject')}
                            value={users.welcomeEmailSubject || DEFAULT_SUBJECT}
                            onChange={this.onChangeValue.bind(this, 'users.welcomeEmailSubject')}
                            onBlur={this.onSaveValue.bind(this, 'users.welcomeEmailSubject')}
                        />

                        <Editor
                            label={t('message')}
                            tags={['naam', 'bedrijfsnaam']}
                            value={body}
                            onChange={this.onSaveValue.bind(this, 'users.welcomeEmailBody')}
                        />

                        <UploadImage
                            label={t('welcomeMailPhoto')}
                            subText={t('ttsPhotoSize', `${width} × ${height}`)}
                            image={photo}
                            accept='image/png,image/jpeg'
                            resize={false}
                            maxSize={10}
                            onChange={(dataUrl) => this.onChangePhoto(dataUrl)}
                        />
                        {this.state.photoError && <Alert variant='danger'>{this.state.photoError}</Alert>}
                    </FormStack>
                </Card>

                <div style={{width: 650}}>
                    <EmailPreview
                        type='userWelcome'
                        html={userWelcomeTemplate({
                            logo: reseller.settings.logo || '/images/logoPlaceholder.png',
                            color: reseller.settings.color,
                            message: body.replace(/\n/g, '<br/>'),
                            token: '',
                            loginEmail: 'gebruiker@voorbeeld.nl',
                            photo
                        }, window.location.origin)}
                    />
                </div>
            </Row>
        )
    }
}

export default UserWelcomeSettings
